import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TopSectionNew.css';
import img1 from "../../../../assets/home/posters/festive/1.png";
import img2 from "../../../../assets/home/posters/festive/2.png";
import img3 from "../../../../assets/home/posters/festive/3.png";
import img4 from "../../../../assets/home/posters/festive/4.png";
// import img5 from "../../../../assets/home/posters/basic/Boost.png";
// import img6 from "../../../../assets/home/posters/basic/tjp-ugadi.png";

import bgOne from '../../../../assets/home/topSection/bgOne.png';

const slides = [
  {
    imgSrc: img1,
    heading: "The Ultimate\nFestive Wellness",
    paragraph: "A curated collection of our best millets.\nPerfect for every celebration and dietary need.\nBring home the complete nutrition pack.",
    slideName: "FESTIVE WELLNESS",
  },
  {
    imgSrc: img2,
    heading: "New Year,\nNew Healthy You",
    paragraph: "Kickstart your 2026 fitness resolutions.\nFuel your body with sustained energy millets.\nMake health your priority this year.",
    slideName: "NEW YEAR SPECIAL",
  },
  {
    imgSrc: img3,
    heading: "Tradition Meets\nWholesome Health",
    paragraph: "Celebrate the harvest with fiber-rich grains.\nIdeal for traditional Sankranti recipes.\nStay rooted in health and heritage.",
    slideName: "MAKAR SANKRANTI",
  },
  {
    imgSrc: img4,
    heading: "A Very Merry\nMillet Christmas",
    paragraph: "Bake healthier treats with millet flour.\nRich in protein to keep you warm and full.\nGift the joy of wellness to your loved ones.",
    slideName: "MERRY CHRISTMAS",
  },
];

// const slides = [
//   // {
//   //   imgSrc: img6,
//   //   heading: "Go Green with\nSustainability",
//   //   paragraph: "Millets require less water.\nEnvironmentally friendly and sustainable.\nA step towards green living.",
//   //   slideName: "Ugadi",
//   // },
//   // {
//   //   imgSrc: img5,
//   //   heading: "Go Green with\nSustainability",
//   //   paragraph: "Millets require less water.\nEnvironmentally friendly and sustainable.\nA step towards green living.",
//   //   slideName: "BOOST",
//   // },
  
//   {
//     imgSrc: img2,
//     heading: "Regulate Blood Sugar\nNaturally",
//     paragraph: "Millets are low-glycemic.\nIdeal for managing blood sugar levels.\nPrevents spikes effectively.",
//     slideName: "READY TO COOK",
//   },
//   {
//     imgSrc: img3,
//     heading: "Promote A Healthy\nHeart",
//     paragraph: "Rich in fiber and essential nutrients.\nMillets contribute to improved heart health.\nStay heart-healthy naturally.",
//     slideName: "READY TO EAT",
//   },
//   {
//     imgSrc: img4,
//     heading: "Support Weight\nManagement",
//     paragraph: "High in fiber and protein.\nKeeps you fuller for longer.\nSupports a healthy weight.",
//     slideName: "FREE DELIVERY",
//   },
//   {
//     imgSrc: img1,
//     heading: "Nutritional Benefits\nFor Your Health",
//     paragraph: "Discover the power of millet nutrition.\nPacked with vitamins, minerals, and antioxidants.\nSupports overall well-being.",
//     slideName: "BUY 2 GET 1 FREE",
//   },
 
// ];

const TopSectionNew = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel" style={{ height: '90vh', width: '100vw', overflow: 'hidden',
    //  backgroundColor: "#FDF0DD"
      }}>
      <div
        className="slides"
        style={{
          display: 'flex',
          transform: `translateX(-${currentSlide * 100}vw)`,
          transition: 'transform 0.5s ease-in-out',
        }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className="slide"
            style={{
              // minWidth: '100%',
              minWidth: '100vw',
              height: '74vh',
              background: `url(${slide.imgSrc}) center/contain no-repeat`,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              objectFit:'contain',
            }}
            onClick={() => navigate('/milletproducts')}
          >
          </div>
        ))}
      </div>
      <div
        className="slide-titles"
        style={{
          backgroundImage: `url(${bgOne})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor:"#FD7E4B"
        }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide-title ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="circle"></div>
            <span style={{fontFamily:'Arial',fontSize:'16px',fontWeight:'400',color:'#FFFFFF'}}>{slide.slideName}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopSectionNew;

